
import React, { useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button } from "react-bootstrap";

import ConsultaCliente from '../../../../../lib/json/consultas/Clientes.json'

import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";
import { useNavigate, useParams } from "react-router-dom";
import { ConsultaAPI } from "../../../../../backend/ConsultaAPI";
import SubmitForm from "../../../../components/SubmitForm";
import { ConsumoAPI_POST, ConsumoAPI_PUT } from "../../../../../backend/ConsumoAPI";
import { SucessoMsg } from "../../../../contents/VariaveisGlobais";
import { toast } from "react-toastify";
import SelectFixo from "../../../../components/SelectFixo";
import { CancelarButton } from "../../../../components/SubmitForm/styles";
import ResponsiveDataTable from "../../../../components/DataTable";
import { HRDivider } from "./styles";
import axios from "axios";

function FichaCliente(){
    const navigate = useNavigate();
    // define a exibição do Loading
    var [carregar, setCarregar] = useState(false);
    var [inclusao, setInclusao] = useState(true);

    const { idCliente } = useParams();

    // Consulta do grid
    var consultaDefault  = ConsultaCliente.consulta + (idCliente ? ` WHERE Nome = '${idCliente}'` : '');

    const [campoNome, setCampoNome]   = useState('');
    const [campoIdContato, setCampoIdContato] = useState('')
    const [campoNomeContato, setCampoNomeContato] = useState('')
    const [campoTelefone, setCampoTelefone] = useState('')
    const [campoEmail, setCampoEmail] = useState('')
    const [campoNomeUnidade, setCampoNomeUnidade] = useState('')
    const [campoCNPJ, setCampoCNPJ] = useState('')
    const [campoEndereco, setCampoEndereco] = useState('')
    const [campoCEP, setCampoCEP] = useState('')
    const [campoBairro, setCampoBairro] = useState('')
    const [campoMunicipio, setCampoMunicipio] = useState('')
    const [campoUF, setCampoUF] = useState('')

    var [dataContato, setDataContato]   = useState([]);

    useEffect(() => {
        if (idCliente){
            setInclusao(false)
            loadCliente();
        }
    }, []);

    // Processa consulta do grid
    const loadCliente = async () => {
        setCarregar(true);
        
        var retConsulta = await ConsultaAPI( consultaDefault );
        
        if (retConsulta.data){
            const dados = retConsulta.data

            let newData = []
            dados.forEach((contato, index) => {
                if (index == 0)
                    setCampoNome(contato.Nome);
                
                newData.push({
                    Id: contato.Id, 
                    nomeContato: contato.Nome_Contato,
                    telefoneContato: contato.Telefone,
                    emailContato: contato.Email,
                    cnpjContato: contato.CNPJ,
                    unidadeContato: contato.Nome_Unidade,
                    cepContato: contato.CEP,
                    enderecoContato: contato.Endereço,
                    bairroContato: contato.Bairro,
                    ufContato: contato.UF,
                    municipioContato: contato.Municipio,
                    deletado: false,
                    new: false
                })
            });

            setDataContato(newData);
        }
        
        setCarregar(false);
    }

    const btnIncluirContatos = () => {
        if (!campoNomeContato){
            toast.warning('O prenchimento do campos Nome é obrigatório.');
            return;
        }
        if (!campoTelefone){
            toast.warning('O prenchimento do campo Telefone é obrigatório.');
            return;
        }
        if (!campoEmail){
            toast.warning('O prenchimento do campo Email é obrigatório.');
            return;
        }
        if (!campoNomeUnidade){
            toast.warning('O prenchimento do campo Unidade é obrigatório.');
            return;
        }
        if (!campoCNPJ){
            toast.warning('O prenchimento do campo CNPJ é obrigatório.');
            return;
        }

        if (campoIdContato){
            const id = campoIdContato
            
            setDataContato((prevData) => 
                prevData.map((participante) => {
                    if (participante.Id === id){
                        return { ...participante, 
                            nomeContato: campoNomeContato,
                            telefoneContato: campoTelefone,
                            emailContato: campoEmail,
                            unidadeContato: campoNomeUnidade,
                            cnpjContato: campoCNPJ,
                            enderecoContato: campoEndereco,
                            cepContato: campoCEP,
                            bairroContato: campoBairro,
                            municipioContato: campoMunicipio,
                            ufContato: campoUF,
                            deletado: false
                        };
                    }else{
                        return participante;
                    } 
                })
            );

            setCampoIdContato('')
        }else{
            const newId = Date.now()
            setDataContato((prevData) => [...prevData, 
                {   Id: newId, 
                    nomeContato: campoNomeContato,
                    telefoneContato: campoTelefone,
                    emailContato: campoEmail,
                    cnpjContato: campoCNPJ,
                    unidadeContato: campoNomeUnidade,
                    cepContato: campoCEP,
                    enderecoContato: campoEndereco,
                    bairroContato: campoBairro,
                    ufContato: campoUF,
                    municipioContato: campoMunicipio,
                    deletado: false,
                    new: true
                }
            ]);
        }

        btnCancelarContato()
    };

    const handleAlterarContato = (row) => {
        setCampoIdContato( row.original.Id )
        setCampoNomeContato( row.values.Nome )
        setCampoTelefone( row.values.Cargo )
        setCampoEmail( row.values.Email )
        setCampoNomeUnidade( row.values.Email )
        setCampoCNPJ( row.values.Email )
        setCampoEndereco( row.values.Email )
        setCampoCEP( row.values.Email )
        setCampoBairro( row.values.Email )
        setCampoMunicipio( row.values.Email )
        setCampoUF( row.values.Email )
    };

    const btnCancelarContato = () => {
        setCampoIdContato( "" )
        setCampoNomeContato( "" )
        setCampoTelefone( "" )
        setCampoEmail( "" )
        setCampoNomeUnidade( "" )
        setCampoCNPJ( "" )
        setCampoEndereco( "" )
        setCampoCEP( "" )
        setCampoBairro( "" )
        setCampoMunicipio( "" )
        setCampoUF( "" )
    }

    const handleExcluirContato = (row) => {
        const deletar = row.original.Id;        
        const newData = dataContato.map((item) => { 
            if (item.Id == deletar){ 
                item.deletado = true 
            } 
            
            return item 
        })

        setDataContato(newData);        
    };

    const handleSalvar = async() =>{
        try {
            // Verificar se todos os campos obrigatórios foram preenchidos
            if (!campoNome) {
                toast.warning('O prenchimento do campo Descrição é obrigatório.');
                return false;
            }

            // Verificar se existem dados de Contato preenchidos
            if (dataContato.length == 0) {
                toast.warning('O prenchimento de ao menos um contato é obrigatório.');
                return false;
            }

            setCarregar(true);
            const rota = 'clientes'
            
            let jsonSalvar = {
                Nome: campoNome,
                Clientes: dataContato
            }

            const retConsumo = await (inclusao
                ? ConsumoAPI_POST(rota, jsonSalvar)
                : ConsumoAPI_PUT(rota, jsonSalvar));
    
            SucessoMsg(retConsumo.description);
        } catch (error) {
            console.error('Error in handleSalvar:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    }

    const handleCNPJ = async (e) => {
        setCampoCNPJ(e.target.value)

        if (e.target.value.trim().length == 14){
            buscarDadosEmpresa(e.target.value)
        }
    }

    const buscarDadosEmpresa = async (cnpj) => {
        try {
            const response = await axios.get(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`);
            const empresa = response.data
            
            setCampoNomeUnidade(empresa.razao_social + ' - ' + empresa.descricao_identificador_matriz_filial)
            setCampoCEP(empresa.cep)
            setCampoEndereco(empresa.logradouro + ' nº.' + empresa.numero)
            setCampoBairro(empresa.bairro)
            setCampoUF(empresa.uf)
            setCampoMunicipio(empresa.municipio)
        } catch (error) {
            console.error("Erro ao buscar dados da empresa:", error);
            toast.error('Falha na busca dos dados pelo CNPJ. Verifique o CNPJ digitado!')
            // throw error;
        }
      };

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Cliente"/>
            </Col>
            <Col md="8" xs="12">
                <InputGeral 
                    label="Nome"
                    tipo='text'
                    value={campoNome}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoNome(e.target.value)}
                    disabled={!inclusao}
                />
            </Col>
        </Row>
        <HRDivider></HRDivider>
        <Row>
            <Col md="10" xs="12">
                <h5>Contato x Unidade: </h5>
            </Col>
        </Row>
        <Row>
            <Col md="5" xs="12">
                <InputGeral 
                    label="Nome Contato"
                    tipo='text'
                    value={campoNomeContato}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoNomeContato(e.target.value)}
                />
            </Col>
            <Col md="2" xs="12">
                <InputGeral 
                    label="Telefone Contato"
                    tipo='text'
                    value={campoTelefone}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoTelefone(e.target.value)}
                />
            </Col>
            <Col md="5" xs="12">
                <InputGeral 
                    label="E-mail Contato"
                    tipo='text'
                    value={campoEmail}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoEmail(e.target.value)}
                />
            </Col>
            <Col md="4" xs="12">
                <InputGeral 
                    label="CNPJ"
                    tipo='text'
                    value={campoCNPJ}  // Define o valor do campo com base no estado
                    onChange={(e) => handleCNPJ(e)}
                />
            </Col>
            <Col md="8" xs="12">
                <InputGeral 
                    label="Unidade"
                    tipo='text'
                    value={campoNomeUnidade}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoNomeUnidade(e.target.value)}
                />
            </Col>
            <Col md="2" xs="12">
                <InputGeral 
                    label="CEP"
                    tipo='text'
                    value={campoCEP}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoCEP(e.target.value)}
                />
            </Col>
            <Col md="7" xs="12">
                <InputGeral 
                    label="Endereço"
                    tipo='text'
                    value={campoEndereco}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoEndereco(e.target.value)}
                />
            </Col>
            <Col md="3" xs="12">
                <InputGeral 
                    label="Bairro"
                    tipo='text'
                    value={campoBairro}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoBairro(e.target.value)}
                />
            </Col>
            <Col md="3" xs="12">
                <InputGeral 
                    label="UF"
                    tipo='text'
                    value={campoUF}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoUF(e.target.value)}
                />
            </Col>
            <Col md="5" xs="12">
                <InputGeral 
                    label="Municipio"
                    tipo='text'
                    value={campoMunicipio}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoMunicipio(e.target.value)}
                />
            </Col>
            <Col md="4" xs="12" className="d-flex align-content-end align-items-end justify-content-end">
                <Col md="6" xs="12">
                    <Button className="w-100" variant="primary" onClick={btnIncluirContatos}>
                        { campoIdContato && "✓ Salvar" || "✚ Adicionar" }
                    </Button>
                </Col>
                
                { campoIdContato && (
                    <Col md="6" xs="12">
                        <CancelarButton className="w-100" variant="warning" onClick={btnCancelarContato}>
                            ✗ Cancelar
                        </CancelarButton>
                    </Col>
                )}
            </Col>
        </Row>

        {dataContato && dataContato.length > 0 && (
            <ResponsiveDataTable 
                habilitaBuscar={false} 
                columns={ [
                            { Header: 'Contato', accessor: 'nomeContato'},
                            { Header: 'Telefone', accessor: 'telefoneContato'},
                            { Header: 'E-mail', accessor: 'emailContato'},
                            { Header: 'Unidade', accessor: 'unidadeContato'},
                            { Header: 'CNPJ', accessor: 'cnpjContato'},
                            { Header: 'UF', accessor: 'ufContato'},
                            { Header: 'Município', accessor: 'municipioContato'}
                        ]}
                data={dataContato.filter(item => item.deletado == false)} 
                buttons= {[
                    {action: handleAlterarContato, label: "Alterar", icone: "MdOutlineEditNote"},
                    {action: handleExcluirContato, label: "Excluir", icone: "MdPlaylistRemove", style: "danger"}
                ]}
            />
        )}
        
        <SubmitForm onSave={handleSalvar} onCancel={"handleCancelar"}></SubmitForm>
        </>
    );
}

export default FichaCliente;